import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/IconCard/sgds-icon-card";
import { register } from "../../utils/ce-registry";

register("sgds-icon-card", Component);

export default createComponent({
  react: React,
  tagName: "sgds-icon-card",
  elementClass: Component,
  events: {}
});
